module.exports = __webpack_public_path__ + "img/budgetcontrol.e9a20024.png";